export const dnsExternalEntryPath = '/OrderInputSystem/deliverynotessystem/specialShippingRequirement';

const storageKey = 'dnsExternalEntry';

export function markDnsExternalEntry() {
  sessionStorage.setItem(storageKey, '1');
}

export function isDnsExternalEntry() {
  return sessionStorage.getItem(storageKey) === '1';
}
